import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/types/applicationContext';
import { getTelemetry } from '@cian/telemetry/browser';
import { createMakeRequest } from '../../../shared/utils/network_helper';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    makeRequest: createMakeRequest(
      getHttpApi(),
      window.location.host,
      window.location.protocol === 'http:' ? 'http' : 'https',
      getLogger(),
    ),
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
  };
};
